<template>
  <v-list nav>
    <v-list-item v-for="item in userMenu" :key="item.link" :to="item.link">
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState } from "vuex";

import { Icon } from "@/helpers";

export default {
  computed: {
    ...mapState("users", {
      user: "user",
    }),
    menu: function () {
      return [
        {
          title: "Главная",
          link: "/",
          icon: Icon.viewDashboard,
          show: this.showMenuItem("/"),
        },
        {
          title: "Заявки",
          link: "/orders",
          icon: Icon.receipt,
          show: this.showMenuItem("/orders"),
        },
        {
          title: "Акции",
          link: "/promotions",
          icon: Icon.sale,
          show: this.showMenuItem("/promotions"),
        },
        {
          title: "Планирование",
          link: "/provisions",
          icon: Icon.finance,
          show: this.showMenuItem("/provisions"),
        },
        {
          title: "Пользователи",
          link: "/users",
          icon: Icon.accountMultiple,
          show: this.showMenuItem("/users"),
        },
        {
          title: "Настройки",
          link: "/settings",
          icon: Icon.settings,
          show: this.showMenuItem("/settings"),
        },
      ];
    },
    userMenu: function () {
      return this.menu.filter((item) => item.show);
    },
  },
  methods: {
    showMenuItem: function (link) {
      const currentMenuRoute = this.$router.options.routes.filter(
        (item) => item.path === link
      );

      if (
        currentMenuRoute[0].meta.authorize &&
        currentMenuRoute[0].meta.authorize.length > 0
      )
        return currentMenuRoute[0].meta.authorize.some((i) =>
          this.user.userRoles.includes(i)
        );

      return true;
    },
  },
};
</script>
